import React from 'react';

const HomePage = () => {
  return (
    <div className="bg-white">
      {/* Первый блок */}
      <div className="container mx-auto py-16 px-4 text-center">
        <h2 className="text-blue-600 font-bold text-lg">Created for Traders, by a Trader</h2>
        <h1 className="mt-4 mb-8 text-5xl font-extrabold text-gray-900 leading-tight">Effortless TradingView to Telegram Alerts</h1>
        <p className="max-w-3xl mx-auto text-gray-700 text-xl mb-6">
          No more manual effort with your <span className="text-blue-600 font-semibold">TradingView alerts</span>. Let TradingHook automate the process, allowing you to focus on making smart trades.
        </p>
        <p className="max-w-2xl mx-auto text-gray-500 text-md mb-6">Easily set up alerts via webhook and get real-time notifications delivered directly to Telegram.</p>
        <a href="/register" className="inline-block bg-blue-600 text-white font-bold py-4 px-8 rounded-lg shadow-md hover:bg-blue-500 hover:shadow-lg transition-all duration-300">Get Started Now</a>
      </div>

      {/* Второй блок с уменьшенными отступами */}
      <section className="py-8 px-4 bg-gray-50"> {/* Изменил py-12 на py-8 */}
        <div className="container mx-auto">
          <div className="max-w-2xl mx-auto text-center mb-8"> {/* Изменил mb-12 на mb-8 */}
            <h2 className="text-3xl font-semibold mb-4">How to Get Alerts in Telegram</h2>
            <p className="text-gray-600 text-lg">Follow these simple steps to start receiving your trading alerts on Telegram.</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 max-w-6xl mx-auto">
            <div className="bg-white p-10 border border-gray-200 rounded-lg shadow-lg text-center hover:shadow-xl transition-shadow duration-300">
              <span className="inline-flex items-center justify-center bg-blue-600 text-white text-lg font-semibold h-12 w-12 rounded-full mx-auto -mt-12">1</span>
              <h3 className="mt-6 mb-4 text-2xl font-medium text-gray-900">Create an Alert</h3>
              <p className="text-gray-600">Generate a webhook URL in the dashboard, and our system will handle sending your TradingView alerts to Telegram instantly!</p>
            </div>

            <div className="bg-white p-10 border border-gray-200 rounded-lg shadow-lg text-center hover:shadow-xl transition-shadow duration-300">
              <span className="inline-flex items-center justify-center bg-green-500 text-white text-lg font-semibold h-12 w-12 rounded-full mx-auto -mt-12">2</span>
              <h3 className="mt-6 mb-4 text-2xl font-medium text-gray-900">Receive Alerts</h3>
              <p className="text-gray-600">Connect with our bot on Telegram, and you'll start receiving real-time notifications. Share them with your trading team easily.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Третий блок */}
      <section className="py-16 px-4">
        <div className="container mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 text-center">
            <div className="p-8">
              <img src="/fast.png" alt="Fast" className="mx-auto mb-6 w-16 h-16" />
              <h4 className="text-xl font-semibold text-gray-900 mb-3">Fast</h4>
              <p className="text-gray-600">Get your TradingView alerts delivered to Telegram in seconds — no more delays, no more switching between apps.</p>
            </div>

            <div className="p-8">
              <img src="/simple.png" alt="Simple" className="mx-auto mb-6 w-16 h-16" />
              <h4 className="text-xl font-semibold text-gray-900 mb-3">Simple</h4>
              <p className="text-gray-600">With just a few clicks, you can set up alerts to receive TradingView notifications in your Telegram — quick and easy.</p>
            </div>

            <div className="p-8">
              <img src="/affordable.png" alt="Affordable" className="mx-auto mb-6 w-16 h-16" />
              <h4 className="text-xl font-semibold text-gray-900 mb-3">Affordable</h4>
              <p className="text-gray-600">Get access to TradingHook’s features at an affordable price, making it the perfect tool for traders of all levels.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;